module.exports = __webpack_public_path__ + "nc_static/media/sw-release-installed.ea2b0fbc.svg";